import onProjectStatusOptionUpdated from './onProjectStatusOptionUpdated';
import onProjectStatusOptionCreated from './onProjectStatusOptionCreated';
import onProjectStatusOptionDeleted from './onProjectStatusOptionDeleted';

export default {
  onProjectStatusOptionUpdated,
  onProjectStatusOptionCreated,
  onProjectStatusOptionDeleted,
};
